const stickersub_rec_Config = {
  sel: {
      cartRecommendationList: '.rebuy-cart__flyout-recommendations .rebuy-product-grid .splide__list',
      sas206ATC: '.sas_206_monthly-sticker-pack .rebuy-product-actions button.rebuy-button',
      cartStickerPack: '#rebuy-cart ul.rebuy-cart__flyout-items .rebuy-cart__flyout-item.product-monthly-sticker-pack',
      cartItemsList: '#rebuy-cart ul.rebuy-cart__flyout-items',
      cartItemsParent: '#rebuy-cart .rebuy-cart__flyout-body div.rebuy-cart__flyout-content',
      cartSubTotal: 'div.rebuy-cart__flyout-actions button.rebuy-cart__checkout-button'
  },
  html: {
      upsellRecommendation: `<div class="rebuy-product-block sas_206_monthly-sticker-pack product-id-7209085796395 tag-sub_save tag-yblocklist splide__slide rebuy-carousel__slide" id="splide03-slide01" style="width: calc(100%);" aria-label="product"><div class="rebuy-product-media"><a href="/products/monthly-sticker-pack?variant=41031871135787&amp;_rdiscovery-handle=monthly-sticker-pack&amp;_rdiscovery-widget=14302" class="rebuy-product-image clickable" style="width: 98px;"><img loading="eager" src="https://cdn.shopify.com/s/files/1/2551/6136/files/silk-sonder-monthly-sticker-pack-32840488091691_400x400.png?v=1714541154" alt="Silk + Sonder Monthly Sticker Pack"></a></div> <div class="rebuy-product-info"><a role="heading" aria-level="5" href="/products/monthly-sticker-pack?variant=41031871135787&amp;_rdiscovery-handle=monthly-sticker-pack&amp;_rdiscovery-widget=14302" aria-label="View Monthly Sticker Pack" class="rebuy-product-title clickable">Monthly Sticker Pack</a> <!----> <!----> <!----> <div class="rebuy-product-price">
      <!----> <div>
          <span class="rebuy-money sale"><span class="sr-only">Sale price</span> <span>$14.99</span></span>
          <span class="rebuy-money compare-at"><span class="sr-only">Original price</span> <span>$18.99</span></span>
      </div></div></div> <!----> <div class="rebuy-product-actions"><!----> <!----> <!----> <button aria-label="Add the product, Monthly Sticker Pack to Cart" type="button" class="rebuy-button"><span>Add</span></button> <button type="button" class="rebuy--decline__button"><span>No Thanks</span></button></div></div>`
  }
};

// Prevent the script from executing multiple times
if (!window.smartCartCustomRegistered) {
  window.smartCartCustomRegistered = true; // Set a global flag to prevent re-execution

  if (!customElements.get('smart-cart-custom')) {
    customElements.define(
      'smart-cart-custom',
      class SmartCartCustom extends HTMLElement {
        constructor() {
          super();
          this.bundleIds = [];
          this.subscriptionIdsByBundleId = {};
          this.bundleIdBySubscriptionId = {};

          if (window.customBundleInfo) {
            const bundleInfos = window.customBundleInfo.split('|');
            bundleInfos.forEach((info) => {
              const data = info.split('*');
              const bundleId = parseInt(data[0]);
              const subIds = data[1].split(',').map(id => parseInt(id));
              this.bundleIds.push(bundleId);
              this.subscriptionIdsByBundleId[bundleId] = subIds;
              subIds.forEach(subId => {
                this.bundleIdBySubscriptionId[subId] = bundleId;
              });
            });
          }

          document.querySelector('button[type="submit"][name="add"]') && document.querySelector('button[type="submit"][name="add"]').setAttribute('disabled', 'true');
          this.counter = 20 * 60;
          this.onCartChange = this.onCartChange.bind(this);

          this.onLneItemDecrease = this.onLneItemDecrease.bind(this);
          this.onLineItemIncrease = this.onLineItemIncrease.bind(this);
          this.onLineItemRemoved = this.onLineItemRemoved.bind(this);

          this.onCheckout = this.onCheckout.bind(this);
          this.onDiscountToggle = this.onDiscountToggle.bind(this);
          this.onSmartCartClick = this.onSmartCartClick.bind(this);
          this.renderDiscount = this.renderDiscount.bind(this);
          this.addFetchProduct = this.addFetchProduct.bind(this);
          
          this.onTimer = this.onTimer.bind(this);
          this.timerId = setInterval(this.onTimer, 1000);

          document.addEventListener('rebuy:cart.change', this.onCartChange);
          document.addEventListener('click', this.onSmartCartClick);
          
          this.selectedDiscount = '';
          this.availableDiscount = '';
          this.getStartedBtn = document.querySelector('.button--get-started');
          this.cartIcon = document.querySelector('.get-started--container .header__icons');
          this.renderDiscountCounter = 0;
          document.addEventListener('rebuy:smartcart.line-item-decrease', this.onLneItemDecrease);
          document.addEventListener('rebuy:smartcart.line-item-increase', this.onLineItemIncrease);
          document.addEventListener('rebuy:smartcart.line-item-removed', this.onLineItemRemoved);
          document.addEventListener('rebuy:smartcart.ready', (event) => {
            document.querySelector('button[type="submit"][name="add"]') && document.querySelector('button[type="submit"][name="add"]').removeAttribute('disabled');
            document.querySelector('#cart-icon-bubble') && document.querySelector('#cart-icon-bubble').classList.remove('hidden');
            this.onCartChange(event);
          });

          document.addEventListener('discountCodeSelected', (ev) => {
            this.selectedDiscount = ev.detail.code;
          });
          document.addEventListener('availableDiscountCodeChanged', (ev) => {
            this.availableDiscount = ev.detail.code;
          });

          // check when recommendation list is loaded
          const checkCondition = setInterval(() => {
            if (document.querySelector(stickersub_rec_Config.sel.cartRecommendationList) != null) {
              clearInterval(checkCondition);
              this.startStickerSubRecommendationFlow();
            }
          }, 100);
        }

        startStickerSubRecommendationFlow() {
          document.body.classList.add('sas_206');
          this.addStickerSubUpsellRecommendation();
          this.toggleStickerSubUpsellView();
          this.stickerSubUpsellSubTotalObserver();
        };

        getRelatedBundleInfo(event) {
          const smartCart = event.detail.cart || window.Rebuy.SmartCart;
          const item = event.detail.item;
          const items = smartCart.items();
          if (this.bundleIds.includes(item.id)) {
            return {
              items: items.filter(subItem => this.subscriptionIdsByBundleId[item.id].includes(subItem.id) && subItem.quantity >= item.quantity),
              isBundle: true,
              smartCart,
              item
            }
          }
          
          if (this.bundleIdBySubscriptionId[item.id]) {
            const bundleId = this.bundleIdBySubscriptionId[item.id];
            return {
              items: items.filter(bundleItem => bundleItem.id === bundleId),
              isBundle: false,
              smartCart,
              item
            }
          }
        }
        onLneItemDecrease(event) {
          const data = this.getRelatedBundleInfo(event);
          if (!data) return;
          const {smartCart, isBundle, item, items } = data;
          if (isBundle) {
            items.forEach(subItem => {
              smartCart.decreaseItem(subItem);
            });
          } else {
            items.forEach(bundleItem => {
              if (bundleItem.quantity >= item.quantity) {
                smartCart.decreaseItem(bundleItem);
              }
            });
          }
        }

        onLineItemIncrease(event) {
          const data = this.getRelatedBundleInfo(event);
          if (!data) return;
          const {smartCart, isBundle, items } = data;
          if (isBundle) {
            items.forEach(subItem => {
                smartCart.increaseItem(subItem);
            });
          }
        }

        onLineItemRemoved(event) {
          // Remove upsell if subscription is removed
          const removedItem = event.detail.item;
          const wasSubscriptionRemoved = removedItem.handle.includes('-subscription-new') | removedItem.handle.includes('-month-plan') | removedItem.handle.includes('monthly-membership');
          // const appAccessProduct = items.find(item => item.handle === "app-access");

          // if (appAccessProduct) {
          //   smartCart1.removeItem(appAccessProduct);
          // }

          if (this.getStartedBtn) {
            this.getStartedBtn.style.display = !wasSubscriptionRemoved ? 'none' : 'block';
          }

          if (wasSubscriptionRemoved) {
            const smartCart = event.detail.cart || window.Rebuy.SmartCart;
            const items = smartCart.items();
            const upsellProduct = items.find(item => item.sku.includes('monthly_journal'));
            
            if (upsellProduct) {
              smartCart.removeItem(upsellProduct);
            }
      
            const lifeWorkbook = items.find(item => item.handle.includes('life-workbook-'));
            if (lifeWorkbook) {
              smartCart.removeItem(lifeWorkbook);
            }
          }

          // Handle bundle
          const data = this.getRelatedBundleInfo(event);
          if (!data) return;
          const {cart, isBundle, item, items } = data;
          if (isBundle) {
            items.forEach(subItem => {
              window.Rebuy.Cart.changeItem({
                id: subItem.key,
                quantity: subItem.quantity - item.quantity
              });
            });
          } else {
            items.forEach(bundleItem => {
              cart.removeItem(bundleItem);
            });
          }
        }

        onCartChange(event) {
          this.renderDiscountCounter = 0;
          const smartCart = event.detail.smartcart || window.Rebuy.SmartCart;
          const items = smartCart.items();
          if (this.cartIcon) {
            this.cartIcon.style.display = items.length > 0 ? 'flex' : 'none';
          }
          
          var countBubbleElm = document.querySelector('.cart-count-bubble')
          if (countBubbleElm) {
            if (items.length > 0) {
              countBubbleElm.classList.remove('visually-hidden');
            } else {
              countBubbleElm.classList.add('visually-hidden');
            }
          }

          if (!SmartCartCustom.checkoutRegistered) {
            smartCart.checkout = this.onCheckout; 
            SmartCartCustom.checkoutRegistered = true;
          }

          const checkoutBtn = document.querySelector('.rebuy-cart__checkout-button');
          if (!checkoutBtn) {
            if (!window.location.href.includes('/cart')) {
              setTimeout(()=>this.onCartChange(event), 1000);
            }
            return true;
          }

          this.availableDiscount = '';
          if (items.some(item => [
            'annual-199-subscription-new', 
            'annual-subscription-new', 
            '12-month-plan', 
            'minimalist-digital-silk-sonder-membership-12-month', 
            'digital-only-silk-sonder-membership-annual'
          ].includes(item.handle))) {
            this.availableDiscount = 'FREEMONTH';
          } else if (items.some(item => item.handle.includes('-subscription-new') | item.handle.includes('-month-plan'))) {
            this.availableDiscount = 'FIVEOFF'
          } else {
            this.availableDiscount = '';
          }
          // if (this.availableDiscount) {
          //   document.dispatchEvent(new CustomEvent('availableDiscountCodeChanged', {
          //     detail: { code: ''}
          //   }));
          // }
          // if (this.availableDiscount !== this.selectedDiscount) {
          //   this.selectedDiscount = '';
          //   document.dispatchEvent(new CustomEvent('discountCodeSelected', {
          //     detail: { code: ''}
          //   }));
          // }
          this.renderDiscount();
          return true;
        }

        onSmartCartClick(ev) {
          if (ev?.target?.classList?.contains('rebuy-cart__discount-button')) {
            ev.stopImmediatePropagation();
            this.onDiscountToggle();
          }
        }

        onDiscountToggle() {
          if (this.availableDiscount !== this.selectedDiscount) {
            this.selectedDiscount = this.availableDiscount;
          } else {
            this.selectedDiscount = '';
          }
          document.dispatchEvent(new CustomEvent('discountCodeSelected', {
            detail: {
              code: this.selectedDiscount
            }
          }));
          this.renderDiscount();
        }

        renderDiscount() {
          // if (!pdpDiscountEnabled()) return;
          const discountName = document.querySelector('.rebuy-cart__discount-name');
          const checkoutBtn = document.querySelector('.rebuy-cart__checkout-button');
          
          if (!discountName) {
            if (this.renderDiscountCounter < 10) {
              setTimeout(this.renderDiscount, 500);
            }
            this.renderDiscountCounter += 1;
            let subTotal = Rebuy.SmartCart.subtotal();
            checkoutBtn.innerHTML = '<span>CHECKOUT • ' + subTotal + '</span>';
            return;
          }

          document.querySelector('.rebuy-cart__discount-name').innerText = this.availableDiscount;
          let subTotal = Rebuy.SmartCart.subtotal();
          
          const applyBtn = document.querySelector('.rebuy-cart__discount-button');
          if (this.selectedDiscount) {
            applyBtn.innerText = 'Remove';
            let total = 0;
            let discountedPrice = 0;
            for (const item of Rebuy.SmartCart.items()) {
              discountedPrice = 0;
              if (['annual-199-subscription-new', 
                  'annual-subscription-new', 
                  '12-month-plan', 
                  'minimalist-digital-silk-sonder-membership-12-month', 
                  'digital-only-silk-sonder-membership-annual'
                ].includes(item.handle) && this.selectedDiscount === 'FREEMONTH') {
                discountedPrice =  item.discounted_price  - 1995;
                total += discountedPrice * item.quantity;
              } else if ((item.handle.includes('-subscription-new') || item.handle.includes('-month-plan'))  && this.selectedDiscount === 'FIVEOFF') {
                discountedPrice = item.discounted_price  / 100 * 95;
                total += (item.quantity * discountedPrice);
              } else {
                total += (item.quantity * item.discounted_price);
              }

              if (discountedPrice > 0) {
                discountedPrice = Math.round(discountedPrice);
                const priceDiv = document.querySelector('.rebuy-cart__flyout-item-price[data-item-id="'+item.id+'"]');
                if (priceDiv) {
                  priceDiv.innerHTML = '<div><span class="rebuy-money sale"><span class="sr-only">Sale price</span> <span>'+Rebuy.util.formatMoney(discountedPrice)+'</span></span> <span class="rebuy-money compare-at"><span class="sr-only">Original price</span> <span>'+Rebuy.util.formatMoney(item.discounted_price)+'</span></span></div>';
                };
              }
            }
            total = Math.round(total);
            // Select the compare amount span
            const compareAmountSpan = document.querySelector('.rebuy-cart__flyout-subtotal-compare-amount');

            // Get the inner HTML of the compare amount span if it exists
            subTotal = compareAmountSpan ? compareAmountSpan.outerHTML : subTotal;
            
            checkoutBtn.innerHTML = 'CHECKOUT • <span>' + Rebuy.util.formatMoney(total)+'</span><span class="original">' + subTotal + '</span>';
          } else {
            applyBtn.innerText = 'Apply';
            checkoutBtn.innerHTML = '<span>CHECKOUT • ' + subTotal + '</span>';
            
            for (const item of Rebuy.SmartCart.items()) {
              if (['annual-199-subscription-new', 
                  'annual-subscription-new', 
                  '12-month-plan', 
                  'minimalist-digital-silk-sonder-membership-12-month', 
                  'digital-only-silk-sonder-membership-annual'
                ].includes(item.handle) || 
                item.handle.includes('-subscription-new') || 
                item.handle.includes('-month-plan')
              ) {
                const priceDiv = document.querySelector('.rebuy-cart__flyout-item-price[data-item-id="'+item.id+'"]');
                if (priceDiv) {
                  priceDiv.innerHTML = '<div><span class="rebuy-money"><span class="sr-only">Price</span> <span>'+ Rebuy.util.formatMoney(item.discounted_price) +'</span></span></div>';
                }
              }
            }
          }
        }

        onTimer() {
          const minute = Math.floor(this.counter / 60);
          const second = this.counter % 60;
          this.counter -= 1;
          
          var minuteElem = document.querySelector('.rebuy-cart__discount-timer-minute');
          if (minuteElem) {
            minuteElem.innerText = minute + '';
            document.querySelector('.rebuy-cart__discount-timer-second').innerText = second < 10 ? '0' + second : '' + second;
          }
        }
      
        onCheckout() {
          if (pdpDiscountEnabled()) {
            const checkoutUrl =  '/checkout?discount=' + (this.selectedDiscount ? this.selectedDiscount : encodeURIComponent(' '));
            window.location.href = checkoutUrl;
          } else {
            window.location.href = '/checkout';
          }
        }

        // **** STICKER PACK UPSELL METHODS ****
        addStickerSubUpsellRecommendation() {
          if (!document.querySelector(stickersub_rec_Config.sel.cartRecommendationList).querySelector(stickersub_rec_Config.sel.sas206ATC)) {
            document.querySelector(stickersub_rec_Config.sel.cartRecommendationList).insertAdjacentHTML('afterbegin', stickersub_rec_Config.html.upsellRecommendation);
            document.querySelector(stickersub_rec_Config.sel.sas206ATC).addEventListener('click', this.addFetchProduct);
          }
        
          // Hide the product from upsell if already added to the cart
          if (document.querySelector(stickersub_rec_Config.sel.cartStickerPack)) {
            document.body.classList.add('sas_206_upsell_hide');
          }
        }

        addFetchProduct() {
          const formData = new FormData();
          formData.append('form_type', 'product');
          formData.append('utf8', '✓');
          formData.append('id', '41031871135787');
          formData.append('product-id', '7209085796395');
          formData.append('selling_plan', '1554743339');
          window.fetch('/cart/add', {
              method: 'POST',
              body: formData,
              headers: {
                  Accept: 'application/json'
              }
          });
      
          this.hidePopup();
        }

        hidePopup() {
          document.body.classList.add('sas_206_popupHide');
          setTimeout(() => {
            if (document.querySelector('.widget-display-popup.is-visible .rebuy-widget-content .rebuy-product-block')) {
              if (document.querySelector('.widget-display-popup.is-visible .rebuy-widget-content .rebuy-modal-close')) {
                document.querySelector('.widget-display-popup.is-visible .rebuy-widget-content .rebuy-modal-close').click();
              }
            }
            document.body.classList.remove('sas_206_popupHide');
          }, 2500);
        }

        toggleStickerSubUpsellView() {
          if (document.querySelector(stickersub_rec_Config.sel.cartStickerPack)) {
            document.body.classList.add('sas_206_upsell_hide');
          } else {
            document.body.classList.remove('sas_206_upsell_hide');
          }
        }

        stickerSubUpsellSubTotalObserver() {
          const targetElement = document.querySelector(stickersub_rec_Config.sel.cartSubTotal);
          const observer = new MutationObserver(() => {
              setTimeout(() => {
                  this.toggleStickerSubUpsellView();
              }, 500);
          });
      
          observer.observe(targetElement, { childList: true, subtree: true });
        }
      }
    );
  }
}
  